import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { Avatar, AvatarFallback, AvatarImage } from './ui/avatar';
import { Badge } from './ui/badge';
import { ScrollArea } from './ui/scroll-area';

const UserListModal = ({ isOpen, onClose, title, users, loading }) => {
    const { t } = useTranslation();

    return (
        <Dialog open={isOpen} onOpenChange={onClose}>
            <DialogContent className="bg-[#1a1a1b] border-gray-800 text-white sm:max-w-[425px]">
                <DialogHeader>
                    <DialogTitle className="text-xl font-bold">{title}</DialogTitle>
                </DialogHeader>
                <ScrollArea className="max-h-[60vh] mt-4 pr-4">
                    {loading ? (
                        <div className="py-8 text-center text-gray-400">{t('common.loading')}</div>
                    ) : users.length > 0 ? (
                        <div className="space-y-4">
                            {users.map((user) => (
                                <Link
                                    key={user.id}
                                    to={`/profile/${user.username}`}
                                    onClick={onClose}
                                    className="flex items-center gap-3 p-2 rounded-lg hover:bg-white/5 transition-colors"
                                >
                                    <Avatar className="h-10 w-10">
                                        <AvatarImage src={user.avatar_url} />
                                        <AvatarFallback className="bg-blue-600">
                                            {user.username?.substring(0, 2).toUpperCase()}
                                        </AvatarFallback>
                                    </Avatar>
                                    <div className="flex-1 min-w-0">
                                        <p className="text-sm font-bold truncate">
                                            {user.display_name || user.username}
                                        </p>
                                        <p className="text-xs text-gray-400 truncate">@{user.username}</p>
                                        {user.positions?.length > 0 && (
                                            <div className="flex gap-1 mt-1">
                                                {user.positions.slice(0, 2).map((pos, idx) => (
                                                    <Badge key={idx} variant="outline" className="text-[10px] h-4 py-0 px-1 border-blue-500/50 text-blue-400">
                                                        {pos}
                                                    </Badge>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                </Link>
                            ))}
                        </div>
                    ) : (
                        <div className="py-8 text-center text-gray-400 italic">
                            {t('common.noResults', 'No users found')}
                        </div>
                    )}
                </ScrollArea>
            </DialogContent>
        </Dialog>
    );
};

export default UserListModal;
